import React from 'react';
import { Tabs, TabSet, Tab, TabPanel } from 'src/components';
import { ManagerCard } from '../ManagerCard';
import { UserCard } from '../UserCard';
import { Security } from '../Security';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { TeamAssignments } from '../Teams';

const UserProfile = () => {
  const { viewTeams } = useFlags();

  return (
    <div className="w-full relative">
      <Tabs>
        <div className="flex flex-col w-full">
          <div className="flex gap-4">
            {/* Sidebar */}
            <div className="w-48 shrink-0">
              <TabSet id="user-profile-tabs" direction="vertical">
                <Tab tabSetId="user-profile-tabs" index={0}>
                  Account
                </Tab>
                <Tab tabSetId="user-profile-tabs" index={2}>
                  Permissions
                </Tab>
                {viewTeams && (
                  <Tab tabSetId="user-profile-tabs" index={3}>
                    Teams
                  </Tab>
                )}
              </TabSet>
            </div>

            {/* Main Content */}
            <div className="flex-1">
              <TabPanel tabSetId="user-profile-tabs" index={0}>
                <div className="flex flex-col gap-6">
                  <UserCard />
                  <ManagerCard />
                </div>
              </TabPanel>
              <TabPanel tabSetId="user-profile-tabs" index={2}>
                <Security />
              </TabPanel>
              {viewTeams && (
                <TabPanel tabSetId="user-profile-tabs" index={3}>
                  <TeamAssignments />
                </TabPanel>
              )}
            </div>
          </div>
        </div>
      </Tabs>
    </div>
  );
};

export default UserProfile;
